module.exports = __webpack_public_path__ + "images/design@2x-c8d7e626751cabbfecb8fc7a09f05834.png";